module.exports = __webpack_public_path__ + "fonts/lato-semibold-greek.7e4b5a4.woff";